<div *ngIf="data; else loading">
  <div *ngIf="hasBackendSupport" class="col-12 d-flex align-items-center mb-3">
    <input
      type="checkbox"
      class="mr-2"
      [checked]="isEditableView"
      (change)="onEditChange($event.target.checked)"
    />
    <label translate>EDIT</label>
  </div>
  <div class="row" *ngFor="let schedule of data">
    <div class="col-12 border-bottom mb-3">
      <!-- CARD -->
      <div class="card">
        <div class="card-header">
          <div class="row w-100 d-flex justify-content-between align-items-center">
            <div class="col-8 d-flex">
              <div
                class="scheduler-avatar rounded-circle d-flex justify-content-center align-items-center border mr-2"
                (click)="showLastExceptionTrace(schedule, content)"
                [ngClass]="{
                  'border-success': schedule.jobdatamap?.exceptionCounter == 0,
                  'border-danger': !(schedule.jobdatamap?.exceptionCounter === 0),
                  'cursor-pointer': schedule.jobdatamap?.lastExceptionDate
                }"
              >
                <i *ngIf="schedule.jobdatamap?.exceptionCounter == 0" class="fas fa-check"></i>
                <span *ngIf="schedule.jobdatamap?.exceptionCounter > 0">{{ schedule.jobdatamap?.exceptionCounter }}</span>
              </div>
              <div class="d-flex flex-column">
                <h5 class="text-break m-0">{{ schedule.jobName }}</h5>
                <span *ngIf="schedule.executionGroup" class="badge badge-secondary align-self-start">
                  Group: {{ schedule.executionGroup }}
                </span>
                <div class="card-subtitle" style="height:25px;">
                  <label translate>LAST_STATUS</label>: <b>{{ schedule.jobdatamap?.lastStatus }}</b>
                  <button
                    *ngIf="schedule.jobdatamap?.lastExceptionDate"
                    type="button"
                    class="btn btn-link p-0"
                    (click)="showLastExceptionTrace(schedule, content)"
                  >
                    <i class="fas fa-question-circle"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div *ngIf="isEditableView" class="scrollable-container">
                @for (email of schedulersEmailList; track email.Email; let i = $index) {
                  <div *ngIf="email.Email !== 'support@gung.se'" class="col-12 d-flex align-items-center">
                    <input
                      type="checkbox"
                      class="mr-2"
                      [checked]="isJobScheduled(schedule.jobName, email)"
                      (change)="onCheckboxChange(schedule.jobName, email.Email, $event.target.checked)"
                    />
                    <label>{{ email.Email }}</label>
                  </div>
                }
              </div>

              <div *ngIf="isEditableView" class="d-flex" style="height:25px;">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [value]="this.newEmailJobName == schedule.jobName ? newEmail : ''"
                  (input)="this.updateNewEmail($event.target.value, schedule.jobName)"
                  placeholder="Enter new email"
                />
                <button class="btn btn-sm btn-primary min-width-70" (click)="addNewEmail(schedule.jobName)" translate>ADD</button>
              </div>
              <div *ngIf="emailError" class="text-danger">{{ emailError }}</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row mt-2">
            <div class="col-6">
              <div class="row">
                <div class="col-6">
                  <label translate>CRON</label>
                </div>
                <div class="col-6 text-right text-break">
                  <b>{{ schedule.cronExpression }}</b>
                </div>
              </div>
              <div class="row pl-2">
                <p class="cron-desc">{{ parseCronExpression(schedule.cronExpression) }}</p>
              </div>
            </div>
            <ng-container *ngIf="schedule.hasDescription">
              <div class="col-3 border-left" translate>DESCRIPTION</div>
              <div class="col-3 text-right text-break" *ngIf="!schedule.descriptionEn; else descriptionEn">
                {{ (schedule.jobName + '_DESCRIPTION') | translate }}
              </div>
              <ng-template #descriptionEn>
                <div class="col-3 text-right text-break">
                  {{ schedule.descriptionEn }}
                </div>
              </ng-template>
            </ng-container>
          </div>
          <div *ngIf="isEditableView" class="row border-bottom mt-1 pb-3">
            <div *ngIf="false" class="col-2 align-items-end">
              <!-- This should not be needed to be set manually for now, thus always false-->
              <label class="wrap-text">{{ "BUFFER_SIZE" }}</label>
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="bufferSizeList?.[schedule.jobName] ? bufferSizeList[schedule.jobName] : 0"
                  (ngModelChange)="setBufferSize(schedule.jobName, $event)"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="col-2 align-items-end">
              <label class="wrap-text">{{ "CONSECUTIVE_THRESHOLD" | translate }}</label>
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="consecutiveThresholdList?.[schedule.jobName] ? consecutiveThresholdList[schedule.jobName] : 0"
                  (ngModelChange)="setConsecutiveThreshold(schedule.jobName, $event)"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="col-2 align-items-end">
              <label class="wrap-text">{{ "LONG_RUNNING_THRESHOLD" | translate }}</label>
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="longRunningThresholdList?.[schedule.jobName] ? longRunningThresholdList[schedule.jobName] : 0"
                  (ngModelChange)="setLongRunningThreshold(schedule.jobName, $event)"
                  placeholder="0"
                />
              </div>
            </div>
          </div>

          <!-- Bootstrap Accordion replacing mat-accordion -->
          <div class="accordion" [id]="'accordion-' + schedule.jobName">
            <div class="card mb-0">
              <div class="card-header p-0" [id]="'heading-' + schedule.jobName">
                <button
                  class="btn btn-link w-100 text-left d-flex justify-content-between align-items-center collapsed"
                  type="button"
                  [attr.data-toggle]="'collapse'"
                  [attr.data-target]="'#collapse-' + schedule.jobName"
                  [attr.aria-expanded]="panelOpenState(schedule.jobName)"
                  [attr.aria-controls]="'collapse-' + schedule.jobName"
                  (click)="panelOpenState(schedule.jobName, !panelOpenState(schedule.jobName))"
                >
                  <span>
                    <i class="fas fa-chevron-right mr-2" [ngClass]="{'fa-chevron-down': panelOpenState(schedule.jobName), 'fa-chevron-right': !panelOpenState(schedule.jobName)}"></i>
                    <label translate>LAST_EXECUTION_TIME</label>
                  </span>
                  <span class="text-right">
                    {{ schedule.jobdatamap?.lastExecutionTime / 1000 }} s
                  </span>
                </button>
              </div>
              <div
                [id]="'collapse-' + schedule.jobName"
                class="collapse"
                [ngClass]="{ 'show': panelOpenState(schedule.jobName) }"
                [attr.aria-labelledby]="'heading-' + schedule.jobName"
                [attr.data-parent]="'#accordion-' + schedule.jobName"
              >
                <div class="card-body ps-2 pe-2">
                  <!-- Expanded data -->
                  <div class="row mt-2 border-bottom">
                    <div class="col-4">
                      <label translate>TRIGGERS</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.triggerCount }}
                    </div>
                  </div>
                  <div class="row mt-2 border-bottom">
                    <div class="col-4">
                      <label translate>EXECUTIONS</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.jobdatamap?.executionCounter }}
                    </div>
                  </div>
                  <div class="row mt-2 border-bottom">
                    <div class="col-4">
                      <label translate>FAILED</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.jobdatamap?.exceptionCounter }}
                    </div>
                  </div>
                  <div class="row mt-2 border-bottom">
                    <div class="col-4">
                      <label translate>NEXT_EXECUTION_TIME</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.nextFireTime | date : dateFormat + ' HH:mm:ss' }}
                    </div>
                  </div>
                  <div class="row mt-2 border-bottom">
                    <div class="col-4">
                      <label translate>LAST_FINISHED_TIME</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.jobdatamap?.lastEndTime && (schedule.jobdatamap?.lastEndTime | date : 'yyyy') !== '1970' ? (schedule.jobdatamap?.lastEndTime | date : dateFormat + ' HH:mm:ss') : '-' }}
                    </div>
                  </div>
                  <div class="row mt-2 border-bottom">
                    <div class="col-4">
                      <label translate>INTERNAL_STATE</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.jobdatamap?.statusDetails.statusString }}
                    </div>
                  </div>
                  <div
                    class="row mt-2 border-bottom"
                    *ngIf="schedule.jobdatamap?.running && schedule.jobdatamap?.lastStartTime"
                  >
                    <div class="col-4">
                      <label translate>STARTED</label>
                    </div>
                    <div class="col-8 text-right text-break">
                      {{ schedule.jobdatamap?.lastStartTime | date : 'longTime' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button
            (click)="triggerJob(schedule)"
            type="button"
            class="btn btn-primary"
            [disabled]="schedule.jobdatamap?.running ? true : undefined"
          >
            <span translate>
              {{ schedule.jobdatamap?.running ? 'EXECUTING' : 'TRIGGER_NOW' }}
              <i *ngIf="schedule.jobdatamap?.running" class="fa fa-spinner fa-spin"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="d-flex align-items-center justify-content-center m-5">
    <div>
      <i class="fa fa-spinner fa-spin fa-7x"></i>
    </div>
  </div>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title" id="modal-basic-title">{{ lastException?.jobName }} - Exception details</h4>
      <span>{{ lastException?.lastExceptionDate }}</span>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pre>{{ lastException?.lastExceptionTrace }}</pre>
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button> -->
  </div>
</ng-template>
